export { default as ProjectCardSkeleton } from './project-card-skeleton';
export type { BasicProjectCardSkeletonProps, ProjectCardSkeletonProps } from './types';
